import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMap$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMap extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cc48737935ef6f68347523afab339e76b83a5de9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '904259984ce1b828985a705351b2784af0ec15f6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '769b0eafd2983ef4653dd2599d8d9b81dbb782eb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.005 2a2.93 2.93 0 0 0-3 2.853c0 1.52.579 2.575 2.7 5.75a.31.31 0 0 0 .508 0c2.206-3.265 2.794-4.25 2.794-5.75A2.93 2.93 0 0 0 11.005 2M11 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-3 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m5-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0-5.205V6.25c0-.39.345-.56.726-.437l2.932.98a.5.5 0 0 1 .342.475v12.039a.5.5 0 0 1-.658.475L14 18l-5.842 1.947a.5.5 0 0 1-.316 0l-5.5-1.833A.5.5 0 0 1 2 17.64V5.695a.5.5 0 0 1 .658-.475l3.531 1.24a.5.5 0 0 1 .342.474v.53c0 .392-.252.607-.763.426L3.5 7.082v9.838l4.5 1.5 5.842-1.947a.5.5 0 0 1 .316 0L18.5 17.92V7.988l-2.158-.72A.5.5 0 0 1 16 6.796", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-map", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-map"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-map":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMap$1);
            }
            break;
    } });
}

const CosmosIconMap = CosmosIconMap$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMap, defineCustomElement };
